import React, { useState } from "react";
import "./attendenceTable.css";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import moment from "moment";

const AttendanceTable3 = ({ getGraphListData, datedash2 }) => {
  const [open, setOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);

  // Transform the data into the required format
  const attendanceData =
    getGraphListData?.map((store) => ({
      store: store.store_name,
      P: store.Present?.length || 0,
      A: store.Absent?.length || 0,
      HD: store["Half-Day"]?.length || 0,
      Leave: store["On-Leave"]?.length || 0,
      WIO: store["Week Off"]?.length || 0,
      LA: store["Late-Arrival"]?.length || 0,
    })) || [];

  // Handle store name click
  const handleStoreClick = (storeName) => {
    const store = getGraphListData.find((s) => s.store_name === storeName);
    if (store) {
      const allStoreData = [
        ...store.Present.map((item) => ({ ...item, status: "Present" })),
        ...store.Absent.map((item) => ({ ...item, status: "Absent" })),
        ...store["Half-Day"].map((item) => ({ ...item, status: "Half-Day" })),
        ...store["On-Leave"].map((item) => ({ ...item, status: "On-Leave" })),
        ...store["Late-Arrival"].map((item) => ({
          ...item,
          status: "Late-Arrival",
        })),
        ...store["Week Off"].map((item) => ({ ...item, status: "Week Off" })),
      ];

      setSelectedCategory({ name: "All Categories", data: allStoreData });
      setSelectedStore(store.store_name);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedCategory(null);
    setSelectedStore(null);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1100,
    bgcolor: "background.paper",
    border: "1px solid #000",
    boxShadow: 24,
    p: 4,
  };

  return (
    <div className="attendance-table-container d-flex flex-column">
      <h2
        style={{
          textAlign: "start",
          width: "100%",
          paddingLeft: "75px",
          marginBottom: "20px",
        }}
      >
        Attendence - {moment(datedash2).format("DD-MM-YYYY")}
      </h2>
      <table className="attendance-table">
        <thead>
          <tr>
            <th>Store</th>
            <th>P</th>
            <th>A</th>
            <th>HD</th>
            <th>L</th>
            <th>Leave</th>
            <th>WO</th>
          </tr>
        </thead>
        <tbody>
          {attendanceData.length > 0 ? (
            attendanceData.map((row, index) => (
              <tr key={index}>
                <td
                  onClick={() => handleStoreClick(row.store)}
                  style={{ cursor: "pointer", color: "#356854" }} // Green clickable style
                  className="store-name"
                >
                  {row.store}
                </td>
                <td>{row.P}</td>
                <td>{row.A}</td>
                <td>{row.HD}</td>
                <td>{row.LA}</td>
                <td>{row.Leave}</td>
                <td>{row.WIO}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
      <Modal open={open} onClose={handleClose}>
        <Box sx={modalStyle}>
          <Typography variant="h6" component="h2" gutterBottom>
            {selectedStore} - Attendance Overview ({selectedCategory?.name})
          </Typography>

          {selectedCategory?.data?.length > 0 ? (
            <table id="example" className="table">
              <thead>
                <tr>
                  <th>Store Name</th>
                  <th>Name</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {selectedCategory.data.map((item, index) => (
                  <tr key={index}>
                    <td>{selectedStore}</td>
                    <td>{item.user_name}</td>
                    <td>
                      <span
                        className={`status-btn status-${item.status?.replace(
                          " ",
                          "-"
                        )}`}
                      >
                        {item.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <Typography>No employees in this category</Typography>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default AttendanceTable3;
